<template>
  <img
    class="wochit-go-qr"
    src="/resources/img/wochit-go-qr.png"
    alt="Scan to download Wochit Go"
  />
</template>

<script>
// Shared Wochit Go QR code (encodes https://wochit.com/go), reused by the
// "Get the Wochit App" modal and the producing/preview promo banners. Size it
// via width/height on this component's root (.wochit-go-qr) in the parent.
export default {
  name: 'WochitGoQr',
};
</script>

<style lang="scss" scoped>
.wochit-go-qr {
  display: block;
}
</style>
